// extracted by mini-css-extract-plugin
var _1 = "aV0YXcuUkL16F07p6AGh";
var _2 = "j3aMYYRVtOH28g5I18Lq";
export { _1 as "content", _2 as "footer" }
